export enum DashboardTabState {
  TODO = 'To_do',
  KPI_METRICS = 'KPI_Metrics',
}
